module.exports = __webpack_public_path__ + "img/code-of-conduct.83ff7d5f.jpg";